import queryString from 'query-string'
import humps from 'humps'
import apiClient from './api-client'

function list(params) {
  const options = { withHeaders: true }

  const query = humps.decamelizeKeys({
    cycleId: params.cycleId,
    deviceTypeId: params.deviceTypeId,
    medicalProviderId: params.medicalProviderId,
    officeLocationId: params.officeLocationId,
    page: params.fulfilledPage,
    perPage: params.fulfilledPageSize,
    q: params.query,
    showDuplicates: params.showDuplicates,
  })

  return apiClient.get(
    queryString.stringifyUrl({
      url: `v2/ehr/orders`,
      query,
    }),
    options,
  )
}

function listMissingOrders(params) {
  const options = { withHeaders: true }
  const query = humps.decamelizeKeys({
    cycleId: params.cycleId,
    page: params.missingPage,
    perPage: params.missingPageSize,
    q: params.missingQuery,
  })

  return apiClient.get(
    queryString.stringifyUrl({
      url: 'v2/ehr/missing-orders',
      query,
    }),
    options,
  )
}

export default {
  list,
  listMissingOrders,
}
